import dayjs from 'dayjs';

import DateUtils from './DateUtils';

export function campaignStatisticsFilter(createdAt: string | Date) {
  return {
    from: DateUtils.formattedDate({
      date: createdAt,
      format: 'YYYY-MM-DD'
    }),
    to: dayjs()
      .utc()
      .format('YYYY-MM-DD')
  };
}
